import { render, staticRenderFns } from "./Jigsaw.vue?vue&type=template&id=aadf5210&scoped=true&"
import script from "./Jigsaw.vue?vue&type=script&lang=js&"
export * from "./Jigsaw.vue?vue&type=script&lang=js&"
import style0 from "./Jigsaw.vue?vue&type=style&index=0&id=aadf5210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadf5210",
  null
  
)

export default component.exports